module.exports = __webpack_public_path__ + "img/3.382202ba.png";